import React, {Dispatch, SetStateAction, useState} from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {
  menuList,
  menuListImage,
  menuListListItem,
  version,
} from '#Client/components/Menu/MenuModal.css';
import {Modal} from '#Client/components/Modal/Modal';
import {trackEvent} from '#Client/components/util';
import {useSavedData} from '#Client/context/SavedData';
import {OPENED_MODAL} from '#Common/types';

type Props = {
  isAdmin: boolean;
  latestVersion: string;
  setOpenedModal: Dispatch<SetStateAction<OPENED_MODAL>>;
  onClose: () => void;
  onSetIsAdmin: Dispatch<SetStateAction<boolean>>;
};

type MenuItem = {
  modalKey: OPENED_MODAL;
  icon: string;
  label: string;
};

const menuItems: MenuItem[] = [
  {
    modalKey: OPENED_MODAL.HOW_TO_PLAY,
    icon: 'icon_how_to_play',
    label: 'How to Play',
  },
  {
    modalKey: OPENED_MODAL.SOLUTIONS,
    icon: 'icon_calendar',
    label: 'Past Solutions',
  },
  {
    modalKey: OPENED_MODAL.SETTINGS,
    icon: 'icon_settings',
    label: 'Settings',
  },
  // {
  //     modalKey: OPENED_MODAL.MY_SCORES,
  //     icon: 'icon_star',
  //     label: 'My Scores',
  // },
  {
    modalKey: OPENED_MODAL.LEADERBOARDS,
    icon: 'icon_rankings',
    label: 'Leaderboards',
  },
  {
    modalKey: OPENED_MODAL.WHAT_IS_NEW,
    icon: 'icon_message',
    label: "What's New",
  },
  // {
  //     modalKey: OPENED_MODAL.SHOP,
  //     icon: 'icon_shop',
  //     label: 'Shop',
  // },
];
export const MenuModal = ({
  isAdmin,
  latestVersion,
  setOpenedModal,
  onClose,
  onSetIsAdmin,
}: Props) => {
  const [clickCount, setClickCount] = useState<number>(0);
  const [userIdClickCount, setUserIdClickCount] = useState<number>(0);
  const {
    savedData: {userId},
    updateUserId,
  } = useSavedData();

  const incrementUserIdClickCount = () => {
    setUserIdClickCount(userIdClickCount + 1);
    if (userIdClickCount >= 10) {
      updateUserId('68e4831b-4f95-4a64-b3e0-ba2b149072ba_2023-02-01');
    }
  };

  return (
    <Modal image={`${IMG_DIR}icon_calendar.png`} title="Menu" onClose={onClose}>
      <>
        <ul className={menuList}>
          {menuItems
            .concat(
              isAdmin
                ? [
                    {
                      modalKey: OPENED_MODAL.ADMIN,
                      icon: 'icon_lightning_purple',
                      label: 'Admin',
                    },
                  ]
                : [],
            )
            .map((menuItem, index) =>
              menuItem.modalKey === OPENED_MODAL.NONE ? (
                <li className={menuListListItem} key={index}>
                  <img
                    className={menuListImage}
                    height="128"
                    src={`${IMG_DIR}${menuItem.icon}.png`}
                    width="128"
                  />
                  <span>
                    <div>{menuItem.label}</div>
                    <div>(Coming soon!)</div>
                  </span>
                </li>
              ) : (
                <li
                  className={menuListListItem}
                  key={index}
                  onClick={() => {
                    trackEvent('click', 'general', 'menu', menuItem.modalKey);
                    setOpenedModal(menuItem.modalKey);
                  }}
                >
                  <img
                    className={menuListImage}
                    height="128"
                    src={`${IMG_DIR}${menuItem.icon}.png`}
                    width="128"
                  />
                  <span>{menuItem.label}</span>
                </li>
              ),
            )}
        </ul>
        <div
          className={version}
          onClick={() => {
            setClickCount(count => {
              if (clickCount > 8) {
                onSetIsAdmin(true);
              }
              return count + 1;
            });
          }}
        >
          <div>App version: {__VERSION__}</div>
          <div>Latest version: {latestVersion}</div>
        </div>
        {isAdmin ? (
          <div className={version} onClick={incrementUserIdClickCount}>
            {userId ? userId : ''}
          </div>
        ) : null}
      </>
    </Modal>
  );
};
